/* TRIO – Sections XL */
(function () {
  'use strict';
  if (window.__trioWow2) return;
  window.__trioWow2 = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ease = function (t) { return 1 - Math.pow(1 - t, 3); };
  var fmt = function (v, dec) { return dec ? v.toFixed(2).replace('.', ',') : String(Math.round(v)); };

  function tween(el, from, to, dur, dec) {
    if (reduce) { el.textContent = fmt(to, dec); return; }
    var t0 = performance.now();
    cancelAnimationFrame(el.__tw);
    (function step(now) {
      var p = Math.min(1, (now - t0) / dur);
      el.textContent = fmt(from + (to - from) * ease(p), dec);
      if (p < 1) el.__tw = requestAnimationFrame(step);
    })(t0);
  }

  function onView(el, cb, threshold) {
    if (!('IntersectionObserver' in window)) { cb(); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { cb(); io.disconnect(); } });
    }, { threshold: threshold || .25 });
    io.observe(el);
  }

  /* Titres qui montent à l'apparition */
  function reveals(root) {
    root.querySelectorAll('[data-tw-rv]').forEach(function (el) { onView(el, function () { el.classList.add('is-in'); }, .4); });
  }

  /* Compteurs à l'apparition */
  function counters(root) {
    root.querySelectorAll('[data-tw-counters]').forEach(function (box) {
      var nums = box.querySelectorAll('[data-to]');
      nums.forEach(function (n) { if (!reduce) n.textContent = n.dataset.from || 0; });
      onView(box, function () {
        nums.forEach(function (n, i) {
          setTimeout(function () { tween(n, parseFloat(n.dataset.from || 0), parseFloat(n.dataset.to), 1500); }, i * 140);
        });
      }, .35);
    });
  }

  /* Modèles : grands noms, image, prix animé */
  function models(sec) {
    var names = sec.querySelectorAll('.tw-name'), imgs = sec.querySelectorAll('.tw-mimg');
    var price = sec.querySelector('[data-tw-price]'), sub = sec.querySelector('[data-tw-msub]'),
        dots = sec.querySelector('[data-tw-mdots]'), link = sec.querySelector('[data-tw-mlink]');
    var cur = 0, timer, paused = false, cycle = parseFloat(sec.dataset.cycle || 4) * 1000, last = parseFloat(names[0].dataset.price);
    function go(i) {
      cur = i;
      names.forEach(function (n, j) { n.setAttribute('aria-selected', j === i ? 'true' : 'false'); });
      imgs.forEach(function (m, j) { m.classList.toggle('is-on', j === i); });
      var n = names[i], to = parseFloat(n.dataset.price);
      tween(price, last, to, 700, true); last = to;
      sub.textContent = n.dataset.sub; link.href = n.dataset.url;
      var tpl = sec.querySelector('template[data-dots="' + i + '"]');
      if (tpl) dots.innerHTML = tpl.innerHTML;
    }
    function next() { if (!paused) go((cur + 1) % names.length); }
    function start() { clearInterval(timer); if (!reduce && !paused) timer = setInterval(next, cycle); }
    names.forEach(function (n, j) {
      n.addEventListener('mouseenter', function () { paused = true; sec.classList.add('is-paused'); clearInterval(timer); go(j); });
      n.addEventListener('click', function () { paused = true; sec.classList.add('is-paused'); clearInterval(timer); go(j); });
      n.addEventListener('focus', function () { go(j); });
    });
    sec.style.setProperty('--cycle', (cycle / 1000) + 's');
    go(0);
    onView(sec, start, .3);
  }

  /* Coloris : fond, grand nom, image */
  function colors(sec) {
    var btns = sec.querySelectorAll('.tc-sw__btn'), imgs = sec.querySelectorAll('.tw-col__img');
    var giant = sec.querySelector('.tw-col__giant'), name = sec.querySelector('.tw-col__name'),
        cta = sec.querySelector('[data-tw-colcta]'), idx = sec.querySelector('[data-tw-colidx]');
    var cur = 0, timer, paused = false;
    function go(k) {
      cur = k;
      var b = btns[k];
      btns.forEach(function (x, j) { x.setAttribute('aria-pressed', j === k ? 'true' : 'false'); });
      imgs.forEach(function (m, j) { m.classList.toggle('is-on', j === k); });
      sec.style.setProperty('--tint', b.dataset.tint);
      giant.innerHTML = '<span>' + b.dataset.name + '</span>';
      name.textContent = b.dataset.name;
      if (idx) idx.textContent = k + 1;
      if (cta && b.dataset.link) cta.href = b.dataset.link;
    }
    btns.forEach(function (b, k) { b.addEventListener('click', function () { paused = true; clearInterval(timer); go(k); }); });
    go(0);
    onView(sec, function () { if (!reduce) timer = setInterval(function () { if (!paused) go((cur + 1) % btns.length); }, 3000); }, .3);
  }

  /* Manifeste : les mots s'allument au défilement */
  function manifesto(sec) {
    var words = sec.querySelectorAll('.w');
    if (reduce || !words.length) return;
    function on() {
      var r = sec.querySelector('.tw-man__text').getBoundingClientRect(), vh = window.innerHeight;
      var p = Math.min(1, Math.max(0, (vh * .85 - r.top) / (r.height + vh * .35)));
      var lit = Math.round(p * words.length);
      words.forEach(function (w, i) { w.classList.toggle('on', i < lit); });
    }
    document.addEventListener('scroll', on, { passive: true, capture: true });
    window.addEventListener('resize', on); on();
  }

  function init(root) {
    root = root || document;
    reveals(root); counters(root);
    root.querySelectorAll('[data-tw-models]').forEach(models);
    root.querySelectorAll('[data-tw-colors]').forEach(colors);
    root.querySelectorAll('[data-tw-man]').forEach(manifesto);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
